import React, { useEffect, useMemo, useState } from "react";
import {
  have_product_reference,
  isOrderRowCod,
} from "../../../../../helpers/OrdersFunctionsGlobal";
import { returnEuroString } from "../../../../../helpers/Utils";
import { LongButton } from "../../../Buttons";
import DeliveryBlockChange from "./delivery_block_change";
import { useDispatch, useSelector } from "react-redux";
import { getParcelTerminal } from "../../../../../redux/Actions/parcelTerminalAction";
import { updateOrderAddress } from "../../../../../redux/Actions/orderAction";
import { Checkbox, Tooltip } from "antd";
import { IconDot } from "../../../../Layout/Icons";

function DeliveryComponent({
  order_rows,
  delivery_add_col,
  carrier,
  orderId,
  total_shipping,
  payment,
  shipping_address,
  updateShippingAddress,
  order_shop_id,
  cod,
  org_total_shipping,
  total_shipping_updated_by_name,
  total_shipping_confirmed_by_id,
  total_shipping_confirmed_by_name,
  nordrent,
}) {
  const dispatch = useDispatch();
  const { parcel_terminals } = useSelector((state) => state.options);
  const [shippingDiffConfirmed, setShippingDiffConfirmed] = useState(
    !!total_shipping_confirmed_by_id
  );
  const [shippingConfirmLoading, setShippingConfirmLoading] = useState(false);

  const order_row_cod = useMemo(() => {
    if (order_rows && Array.isArray(order_rows)) {
      return order_rows.find((order_row) => {
        if (
          !have_product_reference(order_row.product_reference) &&
          isOrderRowCod(order_row.id_product, order_shop_id)
        ) {
          return true;
        }
        return false;
      })?.unit_price_tax_incl;
    }
  }, [order_rows]);

  const parcelTerminalName = useMemo(() => {
    console.log("parcelTerminalName");
    if (!shipping_address?.parcel_terminal_id) return null;
    return dispatch(getParcelTerminal(shipping_address?.parcel_terminal_id))
      ?.label;
  }, [shipping_address?.parcel_terminal_id, parcel_terminals]);

  const hasOriginalShipping =
    org_total_shipping !== null &&
    org_total_shipping !== undefined &&
    org_total_shipping !== "";
  const shippingDifference = hasOriginalShipping
    ? Number(total_shipping) - Number(org_total_shipping)
    : null;
  const hasVisibleShippingDifference =
    shippingDifference !== null && Math.abs(shippingDifference) > 0.001;
  const shippingDiffClassName =
    shippingDifference > 0
      ? "text-success"
      : shippingDifference < 0
      ? "text-danger"
      : "text-muted";
  const shippingDiffValue =
    !hasVisibleShippingDifference
      ? ""
      : `${shippingDifference > 0 ? "+" : ""}${returnEuroString(shippingDifference)}`;

  useEffect(() => {
    if (!hasVisibleShippingDifference) {
      setShippingDiffConfirmed(false);
    }
  }, [hasVisibleShippingDifference, shippingDiffValue]);

  useEffect(() => {
    setShippingDiffConfirmed(!!total_shipping_confirmed_by_id);
  }, [total_shipping_confirmed_by_id]);

  const onConfirmShippingDiff = async (event) => {
    if (!event?.target?.checked || shippingDiffConfirmed || shippingConfirmLoading) {
      return;
    }

    setShippingConfirmLoading(true);
    const result = await dispatch(
      updateOrderAddress(orderId, { total_shipping_confirmed_by_id: true })
    );
    setShippingConfirmLoading(false);

    if (result?.ok) {
      setShippingDiffConfirmed(true);
    }
  };

  return (
    <div className="bg-silver col-12 py-3">
      <div
        className="d-flex justify-content-center align-items-center mb-2"
        style={{ gap: "10px", flexWrap: "wrap" }}
      >
        <LongButton
          text={`Delivery price: ${returnEuroString(
            cod && order_row_cod
              ? +order_row_cod + +total_shipping
              : total_shipping
          )}`}
        />
        {hasVisibleShippingDifference && (
          <div className="d-flex align-items-center" style={{ gap: "8px", fontSize: "0.8rem" }}>
            <IconDot color={shippingDifference > 0 ? "#52c41a" : "#ff4d4f"} />
            {total_shipping_updated_by_name ? (
              <Tooltip title={`Updated by: ${total_shipping_updated_by_name}`}>
                <span className={shippingDiffClassName}>{shippingDiffValue}</span>
              </Tooltip>
            ) : (
              <span className={shippingDiffClassName}>{shippingDiffValue}</span>
            )}
            <Tooltip
              title={
                shippingDiffConfirmed
                  ? `Confirmed by: ${total_shipping_confirmed_by_name || "Confirmed"}`
                  : "Confirm changes"
              }
            >
              <Checkbox
                checked={shippingDiffConfirmed}
                disabled={shippingDiffConfirmed || shippingConfirmLoading}
                onChange={onConfirmShippingDiff}
              />
            </Tooltip>
          </div>
        )}
      </div>
      <div className="text-black">
        {carrier.identifier == "store" ? (
          <span>
            {carrier.name}
            {cod && order_row_cod && (
              <span className="text-warning pl-2">({order_row_cod})</span>
            )}
          </span>
        ) : (
          <React.Fragment>
            <div>
              Delivery method:
              {carrier.name}
              {cod && order_row_cod && (
                <span className="text-warning pl-2">({order_row_cod})</span>
              )}
            </div>
            {!!parcelTerminalName && (
              <div>
                Post machine:
                {parcelTerminalName}
              </div>
            )}
          </React.Fragment>
        )}
      </div>
      {/* Nordrent: hide "Payment:" line */}
      {!nordrent && (
        <div>
          Payment: <span>{payment}</span>
        </div>
      )}
      {delivery_add_col && (
        <React.Fragment>
          <hr />
          <DeliveryBlockChange
            shipping_address={shipping_address}
            orderId={orderId}
            carrier={carrier}
            updateShippingAddress={updateShippingAddress}
            total_shipping={total_shipping}
            payment={payment}
            order_shop_id={order_shop_id}
          />
        </React.Fragment>
      )}
    </div>
  );
}

export default DeliveryComponent;
